import React from "react";
import Box from '@mui/material/Box';
import './home.css';


const HomeLove = (props) => {
    return ( 
        <>
        <Box sx={{backgroundColor:'#F1F1F1',width:'100vw',maxWidth:'100%',height:'100vh',maxheight:'100%'}}>
           
           <div  className="entryword">
            <div className="homelove__head" >{props.head}</div>
            <div className="homelove__subhead" >{props.subhead}</div>
           </div>
           
        </Box>
        </>

 );
}
 
export default HomeLove;